import type { Status } from '@/rtkApi/mddApiSliceGeneratedV2'

/** Visual tokens for the left-rail Search panel (Claude / Cursor prototype). */
export const SEARCH_PANEL_UI = {
	bg: '#F7F7F7',
	border: '#E4E4E4',
	title: '#6A6A6A',
	accent: '#1F4954',
	accentHover: '#163842',
	body: '#2A2A2A',
	subtitle: '#9A9A9A',
	path: '#B6B6B6',
	pillBorder: '#D8D8D8',
	pillText: '#52666C',
	resultsBar: '#F2F2F2',
	highlight: '#FCEAB0',
	lockMine: '#C26401',
	empty: '#B0B0B0',
} as const

export const SEARCH_OBJECT_STATES: Status[] = [
	'logical_in_progress',
	'logical_completed',
	'physical_in_progress',
	'physical_completed',
	'frozen',
]

export const asStatusText = (status?: unknown) => {
	if (typeof status === 'string') return status
	if (Array.isArray(status) && typeof status[0] === 'string') return status[0]
	return ''
}

export type SearchScope = {
	folder: string
	locked: 'all' | 'mine' | null
	state: Status | ''
}

export const EMPTY_SEARCH_SCOPE: SearchScope = {
	locked: null,
	state: '',
	folder: '',
}

export const normalizeSearchState = (state: unknown): Status | '' => {
	const value = asStatusText(state)
	return SEARCH_OBJECT_STATES.includes(value as Status) ? (value as Status) : ''
}

export type SavedSearchFilter = {
	id: string
	name: string
	q: string
	scope: SearchScope
	types: string[]
}

/** Persisted via users/context (settings.structureSearch). */
export type StructureSearchSession = {
	q: string
	scope: SearchScope
	types: string[]
	saved: SavedSearchFilter[]
}

export const EMPTY_STRUCTURE_SEARCH_SESSION: StructureSearchSession = {
	q: '',
	scope: EMPTY_SEARCH_SCOPE,
	types: [],
	saved: [],
}
